import { isUsingNewLayout } from '@app/adapters/silverfin'

import setupDrawers from './drawers/layout'
import setupDrawersNew from './drawers/new-layout'
import setupHotkeys from './drawers/hotkeys'
import { isDOM } from '@app/shared/predicates'

export default (): Array<() => void> => {
  let unsubscribers: Array<() => void> = []

  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    if (!isDOM(doc)) {
      return
    }

    unsubscribers.forEach((unsubscribe) => unsubscribe())

    if (isUsingNewLayout()) {
      unsubscribers = [...setupDrawersNew(doc), setupHotkeys()]
    } else {
      unsubscribers = setupDrawers(doc)
    }
  })

  return unsubscribers
}
